import React from 'react';
import SlidingPanel from './SlidingPanel';

const DetailPanel = ({
  isOpen,
  onClose,
  title,
  children,
  headerContent = null,
  footerContent = null
}) => {
  return (
    <SlidingPanel
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      width="calc(100vw - 280px)"
      headerContent={headerContent}
      footerContent={footerContent}
    >
      {children}
    </SlidingPanel>
  );
};

export default DetailPanel;